const config = {
    baseUrl: 'http://47.106.12.217:7070',
    h5Appid: 'wxd069726abd2b7d23',
    debug: false,
    OSS_PROVIDER: 'aliyun'
}
module.exports = config